import { render, staticRenderFns } from "./InformacionRecuperadaRepresentante.vue?vue&type=template&id=68d758be"
import script from "./InformacionRecuperadaRepresentante.vue?vue&type=script&lang=js"
export * from "./InformacionRecuperadaRepresentante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports